module.exports = __webpack_public_path__ + "static/media/m1_sf_10.871de320.png";